import { render, staticRenderFns } from "./CrearTareaManualModalComponent.vue?vue&type=template&id=68bb0135&"
import script from "./CrearTareaManualModalComponent.vue?vue&type=script&lang=js&"
export * from "./CrearTareaManualModalComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports